import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { formatDateRelativeToToday } from '../../../../utils/date'
import { getEmailProfileMessageParticipantName } from '../EmailProfileMessage.utils'

function getUserValueString({
  getName = getEmailProfileMessageParticipantName,
  getNameConfig = EMPTY_OBJECT,
  user,
}) {
  const name = getName(user, getNameConfig)

  const email = `<${user.email}>`

  return name ? `${name} ${email}` : email
}

function mapUsersToDropdownOptions(users) {
  return users.map(user => ({
    id: user.id,
    label: getUserValueString({ user }),
  }))
}

export function getToStringValue(data) {
  return data.to.map(user => user.fullname || user.email).join(', ')
}

export function getDropdownData({ data, locale, t, timezone }) {
  return [
    {
      label: t('EmailProfile.AdditionalMessageDataDropdownFromLabelKey'),
      value: getUserValueString({
        getNameConfig: { nameKey: 'name' },
        user: data.sender,
      }),
    },
    {
      label: t('EmailProfile.AdditionalMessageDataDropdownToLabelKey'),
      value: mapUsersToDropdownOptions(data.to),
    },
    ...(data.cc?.length > 0
      ? [
          {
            label: t('EmailProfile.AdditionalMessageDataDropdownCcLabelKey'),
            value: mapUsersToDropdownOptions(data.cc),
          },
        ]
      : EMPTY_LIST),
    ...(data.bcc?.length > 0
      ? [
          {
            label: t('EmailProfile.AdditionalMessageDataDropdownBccLabelKey'),
            value: mapUsersToDropdownOptions(data.bcc),
          },
        ]
      : EMPTY_LIST),

    {
      label: t('EmailProfile.AdditionalMessageDataDropdownCreatedLabelKey'),
      value: formatDateRelativeToToday(data.created, locale, timezone),
    },
    {
      label: t('EmailProfile.AdditionalMessageDataDropdownSubjectLabelKey'),
      value: data.subject,
    },
  ]
}
